'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _util = require('./_util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var guid = 0;

/**
 HTML widget controlling audio stream (play, pause, stop, seek etc).

 Inspired by http://tympanus.net/Development/AudioPlayer/
 */

var Panel = (function () {
  function Panel(container, audio, options) {
    _classCallCheck(this, Panel);

    options = _jquery2.default.extend({
      classPrefix: 'audiopanel',
      strPlay: 'Play',
      strPause: 'Pause',
      strVolume: 'Volume',
      unknownTime: '&hellip;'
    }, options);
    this._options = options;
    this._audio = audio;
    this._id = guid++;
    audio.on('volume', this.volume.bind(this));

    this._audioListeners = undefined;
    this._track = undefined;

    this._triggerObj = (0, _jquery2.default)(this);
    this._trigger = this._triggerObj.triggerHandler.bind(this._triggerObj);
    this._eventsBinded = false;
    this._playing = false;
    this._waiting = false;
    this._playAfterPositionMove = false;
    this._seek = 0; // Current audio position (0.0 - 1.0)
    this._volume = 1;
    this._muteVolume = 1; // Volume before mute
    this._duration = undefined; // Audio file duration in seconds
    this._callbacks = {};

    this._render(container);
  }

  _createClass(Panel, [{
    key: 'load',
    value: function load(track) {
      this._debug('load title=' + track.title + ' duration=' + track.duration);
      if (!this._track || this._track.src !== track.src) {
        this._unbindAudioEvents();
        this._pause();
        this.seek(0);
        this._onAudioLoadProgress(0);
        this._track = _jquery2.default.extend(track, { id: this._id + ':' + track.src });
        this._$theTitleText.text(track.title || '');
        this._$theTitle.attr('title', track.title || '');
        if (track.duration) {
          this._duration = (0, _util.timeToSeconds)(track.duration);
          this._$timeDuration.html(secondsToTime(this._duration));
          this._$timeCurrent.html(secondsToTime(this._seek * this._duration));
        } else {
          this._duration = undefined;
          this._$timeDuration.html(this._options.unknownTime);
          this._$timeCurrent.html(this._options.unknownTime);
        }
        this._trigger('load', [track]);
      }
    }
  }, {
    key: 'play',
    value: function play() {
      this._play('play', true);
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      if (this._playing || this._waiting) {
        this.pause();
      } else {
        this.play();
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._pause('pause', true);
    }
  }, {
    key: 'seek',
    value: function seek(_seek) {
      var prevSeek = this._seek;
      this._onAudioTimeProgress(_seek);
      if (this._seek != prevSeek) {
        if (this._playing || this._waiting) {
          this._audio.seek(_seek);
        }
        this._trigger('seek', [_seek]);
      }
    }
  }, {
    key: 'volume',
    value: function volume(vol) {
      if (vol !== this._volume) {
        this._debug('volume vol=' + vol + ' this._volume=' + this._volume);
        //this._$volumeAdjuster.find('div').height(vol * 100 + '%');
        this._$volumeAdjuster.find('div').width(vol * 100 + '%');
        if (vol > 0) {
          if (this._volume === 0) {
            this._$panel.removeClass(this._cssClass.muted);
          }
        } else {
          if (this._volume > 0) {
            this._$panel.addClass(this._cssClass.muted);
          }
        }
        this._volume = vol;
        this._audio.volume(vol);
        this._trigger('volume', [vol]);
      }
    }
  }, {
    key: 'on',
    value: function on(eventName, callback) {
      var handler = function handler() {
        callback.apply(null, Array.prototype.slice.call(arguments, 1));
      };
      this._triggerObj.on(eventName, handler);
      if (typeof callback.audio_guid === "undefined") {
        callback.audio_guid = guid++;
      }
      this._debug('on eventName=' + eventName + ' callback.audio_guid=' + callback.audio_guid);
      this._callbacks[eventName + ':' + callback.audio_guid] = handler;
      return this;
    }
  }, {
    key: 'off',
    value: function off(eventName, callback) {
      var handler = this._callbacks[eventName + ':' + callback.audio_guid];
      if (handler) {
        delete this._callbacks[eventName + ':' + callback.audio_guid];
        this._triggerObj.off(eventName, handler);
      }
      return this;
    }
  }, {
    key: '_play',
    value: function _play(eventName, useAudio) {
      var track = this._track;
      this._debug('play this._playing=' + this._playing + ' this._waiting=' + this._waiting + ' track=' + (track ? track.id : ''));
      if (track && !this._playing && !this._waiting) {
        var strPause = this._options.strPause;
        this._$playPause.attr('title', strPause).find('a').html(strPause);
        this._$panel.removeClass(this._cssClass.stopped).removeClass(this._cssClass.waiting).addClass(this._cssClass.playing);
        this._waiting = false;
        this._playing = true;
        this._bindAudioEvents();
        if (useAudio) {
          this._audio.load(track);
          this._audio.seek(this._seek);
          this._audio.volume(this._volume);
          this._audio.play();
        }
        if (eventName) {
          this._trigger(eventName);
        }
      }
    }
  }, {
    key: '_pause',
    value: function _pause(eventName, useAudio) {
      this._debug('_pause this._playing=' + this._playing + ' this._waiting=' + this._waiting + ' this._playAfterPositionMove=' + this._playAfterPositionMove);
      if (this._playing || this._waiting) {
        this._$playPause.attr('title', this._options.strPlay).find('a').html(this._options.strPlay);
        this._$panel.removeClass(this._cssClass.playing).removeClass(this._cssClass.waiting).addClass(this._cssClass.stopped);
        this._waiting = false;
        this._playing = false;
        if (useAudio) {
          this._audio.pause();
        }
        if (eventName) {
          this._trigger(eventName);
        }
      }
    }
  }, {
    key: '_onAudioPlay',
    value: function _onAudioPlay() {
      this._play(null, false);
    }
  }, {
    key: '_onAudioPause',
    value: function _onAudioPause() {
      this._pause(null, false);
    }
  }, {
    key: '_onAudioDuration',
    value: function _onAudioDuration(duration) {
      duration = Math.round(duration);
      this._debug('_onAudioDuration this._duration=' + this._duration + ' duration=' + duration);
      if (this._duration !== duration) {
        if (typeof this._duration !== 'undefined') {
          console.warn('Duration changed from ' + secondsToTime(this._duration) + ' to ' + secondsToTime(duration) + ' on track ' + this._$theTitleText.text());
        }
        this._$timeDuration.html(secondsToTime(duration));
        this._duration = duration;
        var position = Math.round(this._seek * this._duration);
        this._$timeCurrent.html(secondsToTime(position));
      }
    }
  }, {
    key: '_onAudioLoadProgress',
    value: function _onAudioLoadProgress(progress) {
      this._$barLoaded.width(Math.round(progress * 100) + '%');
    }
  }, {
    key: '_onAudioTimeProgress',
    value: function _onAudioTimeProgress(seek) {
      seek = Math.round(1000 * seek) / 1000;
      if (seek !== this._seek) {
        this._$barPlayed.width(seek * 100 + '%');
        if (this._duration) {
          var position = Math.round(seek * this._duration);
          var currPosition = Math.round(this._seek * this._duration);
          if (position !== currPosition) {
            this._debug('seek seek=' + seek + ' position=' + position + ' currPosition=' + currPosition);
            this._$timeCurrent.html(secondsToTime(position));
          }
        }
        this._seek = seek;
      }
    }
  }, {
    key: '_onAudioWaiting',
    value: function _onAudioWaiting() {
      this._debug('_onAudioWaiting this._playing=' + this._playing + ' this._waiting=' + this._waiting);
      if (this._playing) {
        this._waiting = true;
        this._playing = false;
        this._$panel.removeClass(this._cssClass.stopped).removeClass(this._cssClass.playing).addClass(this._cssClass.waiting);
        this._trigger('waiting');
      }
    }
  }, {
    key: '_onAudioContinue',
    value: function _onAudioContinue() {
      if (this._waiting) {
        this._waiting = false;
        this._playing = true;
        this._$panel.removeClass(this._cssClass.stopped).removeClass(this._cssClass.waiting).addClass(this._cssClass.playing);
        this._trigger('continue');
      }
    }
  }, {
    key: '_onAudioEnd',
    value: function _onAudioEnd() {
      if (this._playing || this._waiting) {
        this._pause();
        this.seek(0);
        this._trigger('end');
      }
    }
  }, {
    key: '_onAudioUnload',
    value: function _onAudioUnload(track) {
      this._debug('_onAudioUnload track.id=' + track.id);
      if (this._track && this._track.id === track.id) {
        this._unbindAudioEvents();
        this._pause();
        this._onAudioLoadProgress(0);
        this._trigger('unload');
      }
    }
  }, {
    key: '_bindAudioEvents',
    value: function _bindAudioEvents() {
      this._debug('_bindAudioEvents');
      if (!this._audioListeners) {
        this._audioListeners = {
          onDuration: this._onAudioDuration.bind(this),
          onLoadProgress: this._onAudioLoadProgress.bind(this),
          onTimeProgress: this._onAudioTimeProgress.bind(this),
          onPlay: this._onAudioPlay.bind(this),
          onPause: this._onAudioPause.bind(this),
          onSeek: this._onAudioTimeProgress.bind(this),
          onWaiting: this._onAudioWaiting.bind(this),
          onContinue: this._onAudioContinue.bind(this),
          onEnd: this._onAudioEnd.bind(this),
          onUnload: this._onAudioUnload.bind(this)
        };
      }
      if (!this._eventsBinded) {
        this._eventsBinded = true;
        this._audio.on('duration', this._audioListeners.onDuration).on('loadProgress', this._audioListeners.onLoadProgress).on('timeProgress', this._audioListeners.onTimeProgress).on('play', this._audioListeners.onPlay).on('pause', this._audioListeners.onPause).on('seek', this._audioListeners.onSeek).on('waiting', this._audioListeners.onWaiting).on('continue', this._audioListeners.onContinue).on('end', this._audioListeners.onEnd).on('unload', this._audioListeners.onUnload);
      }
    }
  }, {
    key: '_unbindAudioEvents',
    value: function _unbindAudioEvents() {
      this._debug('_unbindAudioEvents');
      if (this._eventsBinded) {
        this._eventsBinded = false;
        this._audio.off('duration', this._audioListeners.onDuration).off('loadProgress', this._audioListeners.onLoadProgress).off('timeProgress', this._audioListeners.onTimeProgress).off('play', this._audioListeners.onPlay).off('pause', this._audioListeners.onPause).off('seek', this._audioListeners.onSeek).off('waiting', this._audioListeners.onWaiting).off('continue', this._audioListeners.onContinue).off('end', this._audioListeners.onEnd).off('unload', this._audioListeners.onUnload);
      }
    }
  }, {
    key: '_render',
    value: function _render(container) {
      var cssClass = {};
      var cssClassSub = {
        playPause: 'playpause',
        playing: 'playing',
        waiting: 'waiting',
        seeking: 'seeking',
        stopped: 'stopped',
        title: 'title',
        titleText: 'title-text',
        time: 'time',
        timeCurrent: 'time-current',
        timeDuration: 'time-duration',
        bar: 'bar',
        barLoaded: 'bar-loaded',
        barPlayed: 'bar-played',
        volume: 'volume',
        volumeButton: 'volume-button',
        volumeAdjust: 'volume-adjust',
        noVolume: 'novolume',
        muted: 'muted',
        mini: 'mini'
      };
      var params = this._options;
      for (var subName in cssClassSub) {
        cssClass[subName] = params.classPrefix + '-' + cssClassSub[subName];
      }
      this._cssClass = cssClass;

      var $panel = this._createPanel(params, cssClass);
      this._$panel = $panel;
      this._$theBar = $panel.find('.' + cssClass.bar);
      this._$barLoaded = $panel.find('.' + cssClass.barLoaded);
      this._$playPause = $panel.find('.' + cssClass.playPause);
      this._$theTitle = $panel.find('.' + cssClass.title);
      this._$theTitleText = this._$theTitle.find('.' + cssClass.titleText);
      this._$barPlayed = $panel.find('.' + cssClass.barPlayed);
      this._$timeCurrent = $panel.find('.' + cssClass.timeCurrent + ' > div');
      this._$timeDuration = $panel.find('.' + cssClass.timeDuration + ' > div');
      this._$volumeButton = $panel.find('.' + cssClass.volumeButton);
      this._$volumeAdjuster = $panel.find('.' + cssClass.volumeAdjust + ' > div');

      this._onVolumeMove = this._onVolumeMove.bind(this);
      this._onPositionMove = this._onPositionMove.bind(this);
      this._onPositionStopMove = this._onPositionStopMove.bind(this);
      this._onVolumeStopMove = this._onVolumeStopMove.bind(this);
      this._$panel.addClass(cssClass.stopped);
      this._$timeDuration.html(this._options.unknownTime);
      this._$timeCurrent.html(this._options.unknownTime);

      this._isTouch = 'ontouchstart' in window;
      this._moveEventName = this._isTouch ? 'touchmove' : 'mousemove';
      var startEventName = this._isTouch ? 'touchstart' : 'mousedown';
      this._$playPause.on('click', this._onPlayPauseClick.bind(this));
      this._$theBar.on(startEventName, this._onPositionStartMove.bind(this));
      this._$volumeButton.on('click', this._onVolumeButtonClick.bind(this));
      this._$volumeAdjuster.on(startEventName, this._onVolumeStartMove.bind(this));
      this._$theBar.on('touchcancel', this._onPositionStopMove);
      (0, _jquery2.default)(container).append($panel);
    }
  }, {
    key: '_createPanel',
    value: function _createPanel(params, cssClass) {
      return (0, _jquery2.default)('<div class="' + params.classPrefix + '">' + '<div class="' + cssClass.playPause + '" title="' + params.strPlay + '">' + '<a href="#">' + params.strPlay + '</a>' + '</div>' + '<div class="' + cssClass.title + '"><div><div><div class="' + cssClass.titleText + '"></div></div></div></div>' + '<div class="' + cssClass.time + ' ' + cssClass.timeCurrent + '"><div></div></div>' + '<div class="' + cssClass.bar + '">' + '<div class="' + cssClass.barLoaded + '"></div>' + '<div class="' + cssClass.barPlayed + '"></div>' + '</div>' + '<div class="' + cssClass.time + ' ' + cssClass.timeDuration + '"><div></div></div>' + '<div class="' + cssClass.volume + '">' + '<div class="' + cssClass.volumeButton + '" title="' + params.strVolume + '">' + '<a href="#">' + params.strVolume + '</a>' + '</div>' + '<div class="' + cssClass.volumeAdjust + '">' + '<div><div></div></div>' + '</div>' + '</div>');
    }
  }, {
    key: '_onPlayPauseClick',
    value: function _onPlayPauseClick() {
      this._debug('_onPlayPauseClick this._playing=' + this._playing + ' this._waiting=' + this._waiting);
      this.togglePlay();
      return false;
    }
  }, {
    key: '_onPositionStartMove',
    value: function _onPositionStartMove(evt) {
      this._debug('_onPositionStartMove');
      this._playAfterPositionMove = this._playing || this._waiting;
      if (this._playAfterPositionMove) {
        this._waiting = false;
        this._playing = false;
        this._audio.pause();
      }
      if (this._isTouch) {
        this._$theBar.one('touchend', this._onPositionStopMove);
      } else {
        (0, _jquery2.default)(document).one('mouseup', this._onPositionStopMove);
      }
      (0, _jquery2.default)(document).on(this._moveEventName, this._onPositionMove);
      this._$panel.addClass(this._cssClass.seeking);
      setTimeout(this._onPositionMove.bind(this, evt), 0);
    }
  }, {
    key: '_onPositionMove',
    value: function _onPositionMove(evt) {
      var originalEvent = this._isTouch ? evt.originalEvent.changedTouches[0] : evt;
      var seek = (originalEvent.pageX - this._$theBar.offset().left) / this._$theBar.width();
      seek = Math.max(0, Math.min(seek, 0.999));
      this._debug('_onPositionMove seek=' + seek + ' duration=' + this._duration + ' evt.type=' + evt.type);
      this.seek(seek);
    }
  }, {
    key: '_onPositionStopMove',
    value: function _onPositionStopMove(evt) {
      this._debug('_onPositionStopMove this._seek=' + this._seek + ' duration=' + this._duration + ' evt.type=' + evt.type);
      this._onPositionMove(evt);
      (0, _jquery2.default)(document).off(this._moveEventName, this._onPositionMove);
      this._$panel.removeClass(this._cssClass.seeking);
      if (this._playAfterPositionMove) {
        this._playing = true;
        this._audio.seek(this._seek);
        this._audio.play();
      }
    }
  }, {
    key: '_onVolumeButtonClick',
    value: function _onVolumeButtonClick() {
      if (this._volume === 0) {
        this.volume(this._muteVolume);
        this._trigger('volume', [this._volume]);
      } else if (!this._isTouch) {
        this._muteVolume = this._volume;
        this.volume(0);
        this._trigger('volume', [0]);
      }
      return false;
    }
  }, {
    key: '_onVolumeStartMove',
    value: function _onVolumeStartMove(e) {
      if (this._isTouch) {
        this._$volumeAdjuster.one('touchcancel', this._onVolumeStopMove);
      } else {
        (0, _jquery2.default)(document).one('mouseup', this._onVolumeStopMove);
      }
      this._muteVolume = this._volume;
      this._onVolumeMove(e);
      this._$volumeAdjuster.parent().on(this._moveEventName, this._onVolumeMove);
    }
  }, {
    key: '_onVolumeMove',
    value: function _onVolumeMove(e) {
      var theRealEvent = this._isTouch ? e.originalEvent.touches[0] : e;
      //var height = this._$volumeAdjuster.height();
      //var top = this._$volumeAdjuster.offset().top;
      //var vol = (top + height - theRealEvent.pageY) / height;
      var width = this._$volumeAdjuster.width();
      var left = this._$volumeAdjuster.offset().left;
      var vol = ( (left + width - theRealEvent.pageX) / width );
      vol = Math.max(0, Math.min(vol, 1));
      vol = 1 - vol; // invert 
      this.volume(vol);
      this._debug('_onVolumeMove vol=' + vol);
      this._trigger('volume', [vol]);
    }
  }, {
    key: '_onVolumeStopMove',
    value: function _onVolumeStopMove() {
      this._$volumeAdjuster.parent().off(this._moveEventName, this._onVolumeMove);
    }
  }, {
    key: '_debug',
    value: function _debug(msg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      _util.debug.apply(null, ['[Panel track=' + (this._track ? this._track.id : '') + '] ' + msg].concat(args));
    }
  }]);

  return Panel;
})();

exports.Panel = Panel;

function secondsToTime(secs) {
  var hoursDiv = secs / 3600,
      hours = Math.floor(hoursDiv),
      minutesDiv = secs % 3600 / 60,
      minutes = Math.floor(minutesDiv),
      seconds = Math.ceil(secs % 3600 % 60);

  if (seconds > 59) {
    seconds = 0;minutes = Math.ceil(minutesDiv);
  }
  if (minutes > 59) {
    minutes = 0;hours = Math.ceil(hoursDiv);
  }
  var time = (hours === 0 ? '' : hours > 0 && hours.toString().length < 2 ? '0' + hours + ':' : hours + ':') + (minutes.toString().length < 2 ? '0' + minutes : minutes) + ':' + (seconds.toString().length < 2 ? '0' + seconds : seconds);
  return time;
}